"use client"

import { useEffect, useState } from "react"
import LoginForm from "../components/LoginForm"
import Dashboard from "../components/Dashboard"
import { logout } from "../utility/auth"

export default function Home() {
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const [userType, setUserType] = useState(null)

  useEffect(() => {
    const checkAuth = () => {
      const token = localStorage.getItem("authToken")
      const type = localStorage.getItem("loginType")
      const expirationDate = localStorage.getItem("expirationDate")

      if (!token || !expirationDate) {
        setIsAuthenticated(false)
        return
      }

      const currentTime = new Date().getTime()
      const expirationTime = new Date(expirationDate).getTime()

      if (currentTime > expirationTime) {
        logout()
        setIsAuthenticated(false)
        setUserType(null)
      } else {
        setIsAuthenticated(true)
        setUserType(type)
      }
    }

    checkAuth()
  }, [])

  const handleLogin = () => {
    const type = localStorage.getItem("loginType")
    setIsAuthenticated(true)
    setUserType(type)
  }

  const handleLogout = () => {
    logout()
    setIsAuthenticated(false)
    setUserType(null)
  }

  if (!isAuthenticated) {
    return <LoginForm onLogin={handleLogin} />
  }

  return <Dashboard userType={userType} onLogout={handleLogout} />
}
